import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AnalyticsLayout from 'components/layout/AnalyticsLayout';
import { getSecuredPages, getPublicPages } from 'redux/actions/pagesActions';
import Header from 'components/layout/Partials/Header';
import { Helmet } from 'react-helmet';
import { defaultStyles } from 'utils/Theme';
import Loading from 'components/common/Loading';
import Dashboard from './Dashboard';

const DashboardContainer = () => {
    const classes = defaultStyles();
    const dispatch = useDispatch();
    const { pages } = useSelector((state) => state.pages);
    const { publicAccess } = useSelector((state) => state.settings);
    const { isAuthenticated } = useSelector((state) => state.auth);
    const isLoading = useSelector(
        (state) => state.pages.loading || state.settings.loading
    );
    const getDynamicOrPublicPages = () => {
        if (isAuthenticated) {
            return dispatch(getSecuredPages());
        }

        if (publicAccess) {
            return dispatch(getPublicPages());
        }
    };

    useEffect(() => {
        if (!pages) {
            getDynamicOrPublicPages();
        }
    }, []);

    useEffect(() => {
        if (!pages) {
            getDynamicOrPublicPages();
        }
    }, [publicAccess]);

    const getHelmet = () => {
        return (
            <Helmet>
                <title>Dashboard</title>
            </Helmet>
        );
    };

    if (isLoading) {
        return <Loading />;
    }

    return (
        <AnalyticsLayout>
            {getHelmet()}
            <Header title="Dashboard" classes={classes} />
            <div className={'full_height u-m-xsmall'}>
                {pages && <Dashboard pages={pages} />}
            </div>
        </AnalyticsLayout>
    );
};

export default DashboardContainer;
